// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3lfjn","inputWrap":"styles_inputWrap__mU2lq","input":"styles_input__tf3tQ"};